import { useEffect, useState } from "react";
import { Loader2, TrendingUp, Wallet, Target, Users, AlertTriangle } from "lucide-react";
import api from "@/lib/api";

function Card({ icon: Icon, label, value, testId }) {
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4" data-testid={testId}>
      <div className="flex items-center gap-2 text-amtm-textMuted text-xs mb-1.5">
        <Icon className="h-3.5 w-3.5" /> {label}
      </div>
      <p className="font-display text-2xl text-amtm-text">{value}</p>
    </div>
  );
}

const money = (paise) => `₹${Math.round((paise || 0) / 100).toLocaleString("en-IN")}`;

export default function PerformanceSummaryCards({ range }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/performance/summary", { params: range }).then(({ data }) => setData(data));
  }, [range]);

  if (!data) {
    return <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-amtm-teal" /></div>;
  }

  return (
    <>
      {data.last_sync?.status === "auth_error" && (
        <div className="bg-destructive/10 border border-destructive/30 text-destructive rounded-xl p-4 mb-4 flex items-start gap-2" data-testid="performance-meta-auth-error-banner">
          <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
          <p className="text-sm">
            <span className="font-semibold">Meta token expired, reconnect.</span> {data.last_sync.error_message}
          </p>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="performance-summary-cards">
        <Card icon={Wallet} label="Ad Spend" value={money(data.totals.spend_paise)} testId="performance-stat-spend" />
        <Card icon={TrendingUp} label="Actual Revenue (attributed)" value={money(data.totals.attributed_revenue_paise)} testId="performance-stat-revenue" />
        <Card icon={Target} label="Real ROAS" value={data.totals.roas != null ? `${data.totals.roas}x` : "—"} testId="performance-stat-roas" />
        <Card icon={Users} label="Attributed Donors" value={data.totals.attributed_donor_count} testId="performance-stat-donors" />
      </div>
    </>
  );
}
